module.exports = __webpack_public_path__ + "img/meituanzhifu.5d4408bb.png";